import { CylinderGeometry, Group, Mesh, MeshBasicMaterial, Raycaster, SphereGeometry, Vector3 } from 'three';

import { Bvh, OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { GroupProps, useFrame } from '@react-three/fiber';
import * as React from 'react';

const pointDist = 5;
const raycaster = new Raycaster();
const origVec = new Vector3();
const dirVec = new Vector3();
const cyl = new CylinderGeometry(0.02, 0.02);
const sph = new SphereGeometry(0.25, 20, 20);
const basOrig = new MeshBasicMaterial({ color: 'yellow', wireframe: true });
const bas = new MeshBasicMaterial({ color: 'red', wireframe: true });
const tra = new MeshBasicMaterial({
  color: 'blue',
  wireframe: true,
  // transparent: true,
  // opacity: 0.25,
});

function Ray(props: { target: React.MutableRefObject<Group> }) {
  const {} = props;
  const objRef = React.useRef<Group>(null!);
  const origMesh = React.useRef<Mesh>(null!);
  const hitMesh = React.useRef<Mesh>(null!);
  const cylinderMesh = React.useRef<Mesh>(null!);

  React.useEffect(() => {
    // objRef.current.position.x = Math.random() * 10;
    // objRef.current.position.y = Math.random() * 10;
    origMesh.current.position.set(pointDist, 0, 0);
    // hitMesh.current.scale.multiplyScalar(0.5);
  }, []);

  // const xDir = Math.random() - 0.5;
  // const yDir = Math.random() - 0.5;

  useFrame((_, delta) => {
    const obj = objRef.current;
    // obj.rotation.x += xDir * delta;
    obj.rotation.y += 4 * delta;
    // origMesh.current.updateMatrixWorld();
    // origVec.setFromMatrixPosition(origMesh.current.matrixWorld);
    // dirVec.copy(origVec).multiplyScalar(-1).normalize();
    raycaster.set(origVec, dirVec);
    raycaster.firstHitOnly = true;
    // const res = raycaster.intersectObject(target.current, true);
    // const length = res.length ? res[0].distance : pointDist;
    // hitMesh.current.position.set(pointDist - length, 0, 0);
    // cylinderMesh.current.position.set(pointDist - length / 2, 0, 0);
    // cylinderMesh.current.scale.set(1, length, 1);
    // cylinderMesh.current.rotation.z = Math.PI / 2;
  });

  return (
    <group ref={objRef}>
      <mesh ref={origMesh} geometry={sph} material={basOrig} />
      <mesh ref={hitMesh} geometry={sph} material={bas} />
      <mesh ref={cylinderMesh} geometry={cyl} material={tra} />
    </group>
  );
}

function Rays(props: GroupProps) {
  const ref = React.useRef<Group>(null!);
  // const { count } = useControls({ count: { value: 1, min: 0, max: 500 } });
  return (
    <>
      <group ref={ref} {...props}>
        {Array.from({ length: 1 }, (_, id) => (
          <Ray key={id} target={ref} />
        ))}
      </group>
    </>
  );
}

export type Props = {};

function App(props: Props) {
  const {} = props;

  return (
    <>
      <Canvas
        camera-position-z={20}
        camera-far={100}
        // camera={{ position: [0, 0, 10] }}
        style={{ height: '30vh', marginBottom: '2rem' }}
      >
        <ambientLight intensity={Math.PI} />
        <pointLight decay={0} position={[10, 10, 5]} />
        <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} decay={0} intensity={Math.PI} />
        <color attach="background" args={['#202025']} />
        {/* <Perf></Perf> */}
        <Bvh>
          <Rays></Rays>
        </Bvh>
        <OrbitControls />
      </Canvas>
    </>
  );
}

export default React.memo(App);
